module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm1_m.a8cd4abc19bbac8a6a8fa010f9020893.png";